// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.img-flag[data-v-79defa98]{\n  width:15px;\n  height:20px\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
